<template>
  <div id="nav" class="nav">
    <nav>
      <router-link :to="{ name: 'EventList' }">Events</router-link> |
      <router-link :to="{ name: 'EventCreate' }">Create</router-link> |
      <router-link :to="{ name: 'About' }">About</router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'NavBar'
};
</script>

<style scoped>
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  margin-left: 25%;
}
.nav > .brand {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 1.5em;
  color: #39b982;
  text-decoration: none;
}
.nav .nav-item {
  box-sizing: border-box;
  margin: 0 5px;
  color: rgba(0, 0, 0, 0.5);
  text-decoration: none;
}
.nav .nav-item.router-link-exact-active {
  color: #39b982;
  border-bottom: solid 2px #39b982;
}
</style>
